import api from './api';
import type { ErpEinstellungen, Nummernkreis } from './erpTypes';

export const NUMMERNKREIS_ART_LABEL: Record<string, string> = {
  rechnung: 'Rechnung',
  gutschrift: 'Gutschrift',
  auftrag: 'Auftrag',
  bestellung: 'Bestellung',
  eingangsrechnung: 'Eingangsrechnung',
  mahnung: 'Mahnung',
  buchung: 'Buchung',
  lieferant: 'Lieferant',
  kunde: 'Kunde',
  projekt: 'Projekt',
};

/** Antwort von GET /erp/einstellungen/bereitschaft. */
export interface ErpBereitschaft {
  bereit: boolean;
  /** Was fuer Rechnungen noch fehlt (Firmenstamm, Steuernummer, Kontenrahmen). */
  maengel: string[];
}

const erpEinstellungenService = {
  async get(): Promise<ErpEinstellungen> {
    const response = await api.get('/erp/einstellungen');
    return response.data;
  },
  async update(daten: Partial<ErpEinstellungen>): Promise<ErpEinstellungen> {
    const response = await api.put('/erp/einstellungen', daten);
    return response.data;
  },
  async nummernkreise(): Promise<Nummernkreis[]> {
    const response = await api.get('/erp/einstellungen/nummernkreise');
    return response.data;
  },
  async bereitschaft(): Promise<ErpBereitschaft> {
    const response = await api.get('/erp/einstellungen/bereitschaft');
    return response.data;
  },
};

export default erpEinstellungenService;
